"use client";

import { c as _c } from "react/compiler-runtime";
import withWatchlist from 'src/components/filmwebid/withWatchlist';
import withWatchlistState from 'src/components/filmwebid/withWatchlistState';
import { getMovieIdentifier } from 'src/lib/filmwebid/useMovieIdentifier';
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import WatchlistActionButton from 'src/components/kommendefilmer/WatchlistActionButton';
import Poster, { type PosterProps } from 'src/components/posterrow/Poster';
import { format, parseISO } from 'date-fns';
import { locale } from "src/lib/locale/date-fns";
import { useLocationContext } from "src/lib/contexts/ContextTypes";
import type { Movie } from 'src/lib/movieinfo/movieinfotypes';
import styles from './KommerPoster.module.css';
import { locale as locl } from "@locale";
import classNames from "classnames";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import { showKinoklubbBanner } from "src/components/kommendefilmer/helperFunctions";
import KinoklubbPosterBanner from "src/kinoklubbposterbanner/KinoklubbPosterBanner";
const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type KommerPosterProps = {
  dateFormat: 'thisweek' | 'thisyear' | 'year';
  forceTicketButton?: boolean;
} & PosterProps;
//#endregion

const WLPoster = withWatchlist(Poster, 'film');
const WLSWatchlistButton = withWatchlistState(WatchlistActionButton);
const DATE_FORMATS = BRAND === "filmweb" ? {
  thisweek: 'EEEE d.M.',
  thisyear: 'd. MMMM',
  year: 'd.M.yyyy'
} : {
  thisweek: 'EEEE d.M.',
  thisyear: 'd. MMMM',
  year: 'd.M.yyyy'
};

//#region [Component]
export default function KommerPoster(props) {
  const $ = _c(26);
  const locContext = useLocationContext();
  const movie = props.film as Movie;
  if (!movie.premiere) {
    return null;
  }
  let dateLabel;
  if ($[0] !== movie.isPremiereConfirmed || $[1] !== movie.premiere || $[2] !== props.dateFormat) {
    const premDate = parseISO(movie.premiere);
    if (movie.isPremiereConfirmed) {
      bb0: switch (props.dateFormat) {
        case "thisweek":
          {
            dateLabel = format(premDate, DATE_FORMATS.thisweek, {
              locale
            });
            break bb0;
          }
        case "thisyear":
          {
            dateLabel = format(premDate, DATE_FORMATS.thisyear, {
              locale
            });
            break bb0;
          }
        case "year":
          {
            dateLabel = format(premDate, DATE_FORMATS.year, {
              locale
            });
          }
      }
    } else {
      dateLabel = format(premDate, "MMMM yyyy", {
        locale
      });
    }
    $[0] = movie.isPremiereConfirmed;
    $[1] = movie.premiere;
    $[2] = props.dateFormat;
    $[3] = dateLabel;
  } else {
    dateLabel = $[3];
  }
  let T0;
  let _isKinoklubb;
  let t0;
  if ($[4] !== props.film || $[5] !== props.hideKinoklubbBanner) {
    const themeStyles = getThemeStyles(styles);
    _isKinoklubb = showKinoklubbBanner(props.film, props.hideKinoklubbBanner);
    T0 = WLPoster;
    t0 = classNames(styles.SWLPoster, themeStyles, styles.PosterImage, "FixedHeightPosterRow");
    $[4] = props.film;
    $[5] = props.hideKinoklubbBanner;
    $[6] = T0;
    $[7] = _isKinoklubb;
    $[8] = t0;
  } else {
    T0 = $[6];
    _isKinoklubb = $[7];
    t0 = $[8];
  }
  let t1;
  if ($[9] !== _isKinoklubb) {
    t1 = _isKinoklubb && <KinoklubbPosterBanner className={styles.Kinoklubb} />;
    $[9] = _isKinoklubb;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== dateLabel) {
    t2 = <div className={styles.SPremiere}>{dateLabel}</div>;
    $[11] = dateLabel;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== locContext || $[14] !== movie || $[15] !== props.forceTicketButton) {
    t3 = !!props.forceTicketButton || locContext.location && movie.showsCount > 0 || movie.showsCount > 10 ? <FilmwebLink className={styles.STicketButton} to={`/film/${movie.mainVersionId}`}>{locl.ticketButton.buyTickets}</FilmwebLink> : <WLSWatchlistButton movieIdentifier={getMovieIdentifier(movie)} dkVariant="light" />;
    $[13] = locContext;
    $[14] = movie;
    $[15] = props.forceTicketButton;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t2 || $[18] !== t3) {
    t4 = <div className={styles.SPremActions}>{t2}{t3}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== T0 || $[21] !== props || $[22] !== t0 || $[23] !== t1 || $[24] !== t4) {
    t5 = <T0 className={t0} posterMissingText={locl.kommer.posterIncoming} showMovieTitleIfPosterIsMissing={true} showInNaturalFormat={true} posterMissingClassName={styles.PosterMissing} hideKinoklubbBanner={true} wlcButtonClassName={styles.TopWatchlistButton} mediumTitle={true} {...props}>{t1}{t4}</T0>;
    $[20] = T0;
    $[21] = props;
    $[22] = t0;
    $[23] = t1;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}
//#endregion